const COMPONENT_EVENTS = {
  Load: {
    description: 'Triggered when user loads page',
    eventHub: {
      code: 'LOAD',
      action: 'On load'
    }
  },
  Continue: {
    description: 'Triggered when user clicks continue button',
    eventHub: {
      code: 'CONTINUE',
      action: 'On click of Continue'
    }
  }
};

const createEventAction = (eventAction, componentName) => {
  return [`${componentName ?? ''}`, `${eventAction ?? ''}`].filter((str) => !!str).join('_');
};

module.exports = {
  transferInApplicationComponentEvents: {
    TransferInTermsAndConditions: {
      code: 'TRANSFERINTERMSANDCONDITIONS',
      events: {
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Load.eventHub.action, 'TransferIn_ThingsToKnow')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'TransferIn_ThingsToKnow')
          }
        }
      }
    },
    TransferInPlanSelect: {
      code: 'TRANSFERINPLANSELECT',
      events: {
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'TransferIn_PlanSelection')
          }
        },
        AddPlan: {
          description: 'Triggered add plan button is clicked',
          eventHub: {
            code: 'ADDPLAN',
            action: 'TransferIn_PlanSelection_On click of Add a plan'
          }
        }
      }
    },
    TransferInDetails: {
      code: 'TRANSFERINDETAILS',
      events: {
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'TransferIn_TransferDetails'),
            dataKeys: [
              'financialInstitution',
              'institutionName',
              'planNumber',
              'address',
              'hasESignature',
              'representative'
            ]
          }
        }
      }
    },
    TransferInAmount: {
      code: 'TRANSFERINAMOUNT',
      events: {
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'TransferIn_EstimatedAmount'),
            dataKeys: ['estimatedAmount']
          }
        },
        TandCClick: {
          description: 'Terms and conditions link clicked',
          eventHub: {
            code: 'TERMSANDCONDITIONS',
            action: 'TransferIn_EstimatedAmount_On click of Terms and Conditions'
          }
        }
      }
    },
    TransferInReview: {
      code: 'TRANSFERINREVIEW',
      events: {
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'TransferIn_Review')
          }
        }
      }
    },
    TransferInDownloadForm: {
      code: 'TRANSFERINDOWNLOADFORM',
      events: {
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'TransferIn_DownloadForm')
          }
        }
      }
    },
    TransferInInstructions: {
      code: 'TRANSFERININSTRUCTIONS',
      events: {
        Done: {
          description: 'Triggered when user clicks done button',
          eventHub: {
            code: 'DONE',
            action: createEventAction('On click of Done', 'TransferIn_NextSteps')
          }
        }
      }
    }
  }
};
